module.exports = __webpack_public_path__ + "static/media/dron-empresa.19b5a427.mp4";